import styled from "styled-components";
import { useMemo, useState } from "react";
import {
  useGetAllFilterConditionQuery,
  useGetAllFilterFieldQuery,
  useGetStatusForFilterRuleQuery,
} from "../../../../../store/apiSlice/newInterfaceApiSlice";
import { InputText } from "../../../components/InputText/InputText";
import { ReactComponent as EditIcon } from "../../../assets/svgIcon/shipment/Edit.svg";
import { ReactComponent as Check } from "../../../assets/svgIcon/listView/check.svg";
import { FilterForOneField } from "./FilterForOneField";
import { DetailsOfRule } from "./DetailsOfRule";
import { orderTypeForUrl } from "../../utils/tableDataElements";
import { apiUrlForStatus } from "./constant";
import {
  useGetListOfProductsQuery,
  useGetListOfSupplierQuery,
  useGetListOfWarehouseQuery,
} from "../../../../../store/apiSlice/reportApiSliceV2";
import { useGetTransferOrdersSelectionQuery } from "../../../../../store/apiSlice/orderApiSlice";
import { useGetPurchaseOrdersSelectionQuery } from "../../../../../store/apiSlice/purchaseOrderApiSlice";
import { useGetCurrencySelectionQuery } from "../../../../../store/apiSlice/currencyApiSlice";

export const ViewRules = ({
  dropDownValues,
  setDropDownValues,
  initialState,
  editPattern,
  setEditPattern,
  orderType,
  allocation,
}) => {
  const selectedFieldIds = useMemo(() => dropDownValues?.map(val => val.field), [dropDownValues]);

  useGetAllFilterConditionQuery();
  useGetAllFilterFieldQuery(
    allocation ? orderTypeForUrl.allocation[allocation].module : orderTypeForUrl[orderType].module,
  );
  useGetStatusForFilterRuleQuery(
    allocation ? apiUrlForStatus[orderType][allocation] : apiUrlForStatus[orderType],
  );
  useGetListOfSupplierQuery();
  useGetListOfWarehouseQuery();
  useGetListOfProductsQuery();
  useGetTransferOrdersSelectionQuery(new URLSearchParams({ mode: "selectable" }).toString(), {
    skip: !(allocation === "transfer"),
  });
  useGetPurchaseOrdersSelectionQuery(new URLSearchParams({ mode: "selectable" }).toString(), {
    skip: !(allocation === "purchase"),
  });

  useGetCurrencySelectionQuery(null, { skip: ![38].some(id => selectedFieldIds?.includes(id)) });

  const [pattern, setPattern] = useState(editPattern);
  const [isEditPattern, setIsEditPattern] = useState(false);

  const openEditPattern = () => {
    setIsEditPattern(true);
  };
  const closeEditPattern = () => {
    setIsEditPattern(false);
  };

  const handleEditPattern = e => {
    setEditPattern(e.target.value);
    setPattern(e.target.value);
  };

  const handleAddMoreCriteria = (index, option) => {
    if (
      dropDownValues[index]["criteria"] === null ||
      !dropDownValues[index]["criteria"] ||
      dropDownValues.length === index + 1
    ) {
      let newPattern = 1;
      if (dropDownValues.length === 1) {
        newPattern = "(" + newPattern + " " + option + " " + 2 + ")";
      } else {
        newPattern = "(" + pattern + " " + option + " " + (index + 2) + ")";
      }

      setPattern(newPattern);
      setEditPattern(newPattern);
      setDropDownValues(state => {
        return [...state, { ...initialState, index: index + 2 }];
      });
    } else {
      let newPattern = 1;
      dropDownValues.forEach((item, ind) => {
        if (ind !== dropDownValues.length - 1) {
          if (index === ind) {
            newPattern = "(" + newPattern + " " + option + " " + (ind + 2) + ")";
          } else {
            newPattern = "(" + newPattern + " " + item["criteria"] + " " + (ind + 2) + ")";
          }
        }
      });
      setPattern(newPattern);
      setEditPattern(newPattern);
    }
  };

  const setPatternAfterDeletion = patternFromDelete => {
    setPattern(patternFromDelete);
    setEditPattern(patternFromDelete);
  };

  return (
    <ViewRulesContainer>
      {dropDownValues.map((item, ind) => (
        <FilterForOneField
          key={ind}
          ind={ind}
          setDropDownValues={setDropDownValues}
          handleAddMoreCriteria={handleAddMoreCriteria}
          dropDownValues={dropDownValues}
          orderType={orderType}
          allocation={allocation}
          setPatternAfterDeletion={setPatternAfterDeletion}
        />
      ))}

      {dropDownValues.length !== 1 ? (
        <div className="pattern">
          Criteria Pattern: &nbsp;
          {isEditPattern ? (
            <p>
              <InputText text={editPattern} setText={handleEditPattern} />
              <span className="iconWrapper" onClick={closeEditPattern}>
                <Check />
              </span>
            </p>
          ) : (
            <p>
              {pattern}{" "}
              <span title="Edit" className="iconWrapper" onClick={openEditPattern}>
                <EditIcon />
              </span>{" "}
            </p>
          )}
        </div>
      ) : (
        <DetailsOfRule />
      )}
    </ViewRulesContainer>
  );
};

const ViewRulesContainer = styled.div`
  .filterForColumn {
    display: flex;
    flex-wrap: wrap;
  }
  .labelForText {
    margin: 0 20px;
    background-color: white;
    gap: 5px;
    width: 210px;
    > input {
      width: 210px;
    }
  }
  .criteria {
    align-self: flex-end;
  }
  .pattern {
    display: flex;
    align-items: center;
    height: 42px;
    margin-left: 20px;

    .labelForText {
      width: auto;
    }
    > p {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 4px;
    }
  }
  .deleteRow {
    align-self: end;
    margin: 20px;
    cursor: pointer;
  }
  .detailsOfRule {
    margin-left: 20px;
    > ul {
      list-style-position: inside;
      color: var(--GREY, #4a4a68);
    }
  }
`;
